import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Authentication, CurrentUser, PenggunaModel, Token} from '../../_model/auth/authentication.model';
import {environment} from '../../../environments/environment';
import {SkpdModel} from "../../pages/shared/skpd.model";

@Injectable({providedIn: 'root'})
export class AuthenticationService {

  private currentLogin = 'currentUser';
  jwtHelperService: JwtHelperService = new JwtHelperService();

  constructor(private http: HttpClient) {
  }

  isAuthenticated(): boolean {
    return localStorage.getItem(this.currentLogin) != null;
  }

  get currentUser(): CurrentUser {
    const currentLogin: CurrentUser = JSON.parse(this.isAuthenticated() ? localStorage.getItem(this.currentLogin) : null);
    return currentLogin;
  }

  get currentUserDetail(): PenggunaModel {
    const currentLogin: CurrentUser = JSON.parse(this.isAuthenticated() ? localStorage.getItem(this.currentLogin) : null);
    if (currentLogin != null){
      const currentUser = currentLogin;
      return currentUser.pengguna;
    }else{
      return null;
    }

  }

  login(auth: Authentication) {
    let header = new HttpHeaders();
    const authBase64 = btoa(environment.clientId + ':' + environment.clientSecret);
    header = header.append('Authorization', `Basic ${authBase64}`);

    let params = new HttpParams();
    params = params.append('username', auth.username);
    params = params.append('password', auth.password);
    params = params.append('grant_type', 'password');

    return this.http.post<Token>(`${environment.uriAuth}/oauth/token`,
      {},
      {
        headers: header,
        params: params,
        observe: 'response'
      });
  }

  setToken(token: Token): void {
    const login: CurrentUser = this.jwtHelperService.decodeToken(token.access_token);
    login.access_token = token.access_token;
    login.expired = this.jwtHelperService.isTokenExpired(token.access_token);
    localStorage.setItem(this.currentLogin, JSON.stringify(login));
  }

  public getListTahunAnggaran(nrk: any) {
    return this.http.get<Token>(`${environment.uriAuth}/api/login/get-tahun-anggaran/${nrk}`, {observe: 'response'});
  }

  isExpired(): boolean {
    let expired = this.currentUser.exp;
    let currentMillis: any = Date.now();
    if(expired.valueOf()*1000>currentMillis){
      return false;
    }else{
      return true
    }
  }

  getSkpd(id: string) {
    return this.http.get<SkpdModel>(`${environment.uriApi}/api/skpd/${id}`);
  }
}
